import ReactGA from "react-ga";

function UserEvent(action: string, label: string) {
  ReactGA.event({
    category: "User Action",
    action,
    label
  });
}

export default UserEvent;
